/**
 * Google Analytics 관련 서비스 함수
 */

import { getUTMParams } from '../utils/utmUtils';

// 페이지 뷰 이벤트 전송
export const trackPageView = (pagePath: string, pageTitle?: string) => {
  // Google Analytics가 로드되었는지 확인
  if (typeof window === 'undefined' || !window.gtag) {
    console.warn('Google Analytics not initialized');
    return;
  }

  // 현재 페이지의 타이틀 가져오기
  const title = pageTitle || document.title || 'KOREA ORDER';

  // 저장된 UTM 파라미터 조회
  const utmParams = getUTMParams();

  // 기본 이벤트 파라미터
  const eventParams: Record<string, any> = {
    page_title: title,
    page_path: pagePath,
    send_to: 'G-G7K2FS7TSC'
  };

  // UTM 파라미터가 있는 경우 이벤트에 포함
  if (utmParams.utm_source) {
    eventParams.utm_source = utmParams.utm_source;
    
    // 원본 UTM이 포함된 URL 정보도 함께 전송 (GA에서 더 정확한 추적을 위해)
    const currentUrl = window.location.href;
    const urlWithUTM = new URL(currentUrl);
    
    // UTM 파라미터를 URL에 다시 추가하여 page_location 생성
    Object.entries(utmParams).forEach(([key, value]) => {
      if (value) {
        urlWithUTM.searchParams.set(key, value);
      }
    });
    
    eventParams.page_location = urlWithUTM.toString();
    
    // 개발 환경에서만 UTM 추적 로그 출력
    if (process.env.NODE_ENV === 'development') {
      console.log('GA 페이지뷰에 UTM 파라미터 포함:', {
        page_path: pagePath,
        utm_source: utmParams.utm_source,
        page_location: eventParams.page_location
      });
    }
  }

  // 페이지 뷰 이벤트 전송
  window.gtag('event', 'page_view', eventParams);
  
};

// 사용자 이벤트 추적 (예: 버튼 클릭, 장바구니 추가 등)
export const trackEvent = (
  eventName: string, 
  eventParams?: Record<string, any>
) => {
  // Google Analytics가 로드되었는지 확인
  if (typeof window === 'undefined' || !window.gtag) {
    console.warn('Google Analytics not initialized');
    return;
  }

  // 이벤트 전송
  window.gtag('event', eventName, eventParams);
  
};

// 홈 화면 배너 클릭 이벤트
export const trackMainBannerClick = (bannerRank: number) => {
  trackEvent('main_bnr_click', {
    bnr_imp_rank: bannerRank
  });
};

// 큐레이션 영역의 가게 클릭 이벤트
export const trackCurationStoreClick = (curationName: string) => {
  trackEvent('store_click_curation', {
    curation_nm: curationName
  });
};

// Bottom Navigation Bar 클릭 이벤트들
export const trackGuidesTabClick = () => {
  trackEvent('click_guides_tab');
};

export const trackOrdersTabClick = () => {
  trackEvent('click_orders_tab');
};

export const trackAddressTabClick = () => {
  trackEvent('click_address_tab');
};

export const trackCartTabClick = () => {
  trackEvent('click_cart_tab');
};

// GA 타입 정의
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
} 